var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g, _g2, _g3, _g4, _g5, _g6, _path26, _g7, _g8, _g9, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160.37 70.77",
    style: {
      enableBackground: "new 0 0 160.37 70.77"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000159460672695176184010000014727922648160443284_);}\n\t.st1{fill:url(#SVGID_00000018927193574422970320000000811234358189903529_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000114775169947206252750000004797925729376980614_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000008830980502267121910000018054189037270020796_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000011729647854662538430000016471618726446481282_);}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#32255C;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000152254462229654522430000016957765724622223801_);}\n\t.st7{fill:#53345F;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#53345F;}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000145777758278576343980000012496371114447087277_);}\n\t\n\t\t.st10{opacity:0.5;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000036240857308509335560000003975971073327488139_);enable-background:new    ;}\n\t\n\t\t.st11{opacity:0.5;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000158749487254615775910000016334819207764518071_);enable-background:new    ;}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000086668423400569644020000001255259484232016257_);}\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:#A73460;}\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000088115281943134721740000007753737507454048134_);}\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000152950679279503615480000015342849446291544723_);}\n\t.st16{opacity:0.5;fill-rule:evenodd;clip-rule:evenodd;fill:#32255C;enable-background:new    ;}\n\t.st17{fill:#FFFFFF;}\n\t\n\t\t.st18{opacity:0.5;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000095340557120395276450000018416223763884786322_);enable-background:new    ;}\n\t.st19{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000090253884199334534770000004046680876862943898_);}\n\t.st20{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000077314831970424528800000015559027529800512663_);}\n\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000102542436100390216350000009049278061472880309_);}\n\t.st22{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000110437588844028530350000007709337354050355077_);}\n\t.st23{fill:#32255C;}\n\t.st24{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000057147954390629711860000018101988095250019213_);}\n\t.st25{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000167390257864367427960000005446177419252489100_);}\n\t.st26{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000037667891730854075580000015407299094902890677_);}\n\t.st27{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000060745259496996161030000005722265350145982140_);}\n\t.st28{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000039133827668233086440000009793433150455131549_);}\n\t.st29{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000168814530836958819670000017654847937876028569_);}\n\t.st30{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000173868870396917293460000014789306822384308628_);}\n\t.st31{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000121237411005008978130000007255372560544508579_);}\n\t.st32{fill-rule:evenodd;clip-rule:evenodd;fill:#702662;}\n\t.st33{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000110468151744962202860000002865039557138569111_);}\n\t.st34{fill-rule:evenodd;clip-rule:evenodd;fill:#EA4E64;}\n\t.st35{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000031903566315218055980000014717469153995174547_);}\n\t.st36{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000016778998820051222070000016836536780012993705_);}\n\t.st37{opacity:0.5;}\n\t.st38{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st39{opacity:0.36;}\n\t.st40{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000070833040074547154230000012408754769827202948_);}\n\t.st41{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000064313910672605328000000001288800707712138422_);}\n\t.st42{fill:url(#SVGID_00000016789417959261133740000003609545822824837049_);}\n\t.st43{fill:url(#SVGID_00000141448661077880821830000014748122308156702119_);}\n\t.st44{fill:url(#SVGID_00000153671015205915253390000002704057329844406166_);}\n\t.st45{fill:url(#SVGID_00000147222263173957264620000013624203958258523546_);}\n\t.st46{fill:url(#SVGID_00000114764236109998820410000002747304526617989775_);}\n\t.st47{fill:url(#SVGID_00000047059641228123820440000000320892982232901269_);}\n\t.st48{fill:url(#SVGID_00000011024991592293506880000013039720015593941412_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 54,
    y: -41.97,
    transform: "matrix(0.0106 -0.9999 0.9999 0.0106 44.3365 114.8079)",
    width: 52.37,
    height: 153.93
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005980347587950467450000011431744101276639888_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000005980347587950467450000011431744101276639888_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183962248374903200650000012873512562186395297_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.8078,
    y1: -0.001269543,
    x2: 108.3828,
    y2: 21.2248,
    gradientTransform: "matrix(0.8855 -0.4647 -0.4647 -0.8855 26.3788 105.0243)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#146E91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183962248374903200650000012873512562186395297_)"
    },
    d: "M112.56,45.89l44.48-0.81l-1.41-18.4 l-42.68-0.82C112.96,25.85,111.66,40.45,112.56,45.89z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172433958837080855640000007576213893557462938_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.6575,
    y1: 36.1121,
    x2: 97.2618,
    y2: 50.3233,
    gradientTransform: "matrix(0.8855 -0.4647 -0.4647 -0.8855 26.3788 105.0243)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A53441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C73735"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000172433958837080855640000007576213893557462938_)"
    },
    d: " M90.49,18.16l-1.32-7.72c0,0,14.17-1.09,29.89,8.34l-0.01,0.73l-21.2-0.81l-0.07,1.54L90.49,18.16z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090262203689355780370000000341328422569194393_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.1498,
    y1: -0.1066,
    x2: 77.7543,
    y2: 14.1052,
    gradientTransform: "matrix(0.8855 -0.4647 -0.4647 -0.8855 26.3788 105.0243)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A53441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C73735"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000090262203689355780370000000341328422569194393_)"
    },
    d: " M90.15,53.33l-1.53,7.9c0,0,14.15,1.38,30.06-7.71l0.01-0.73L97.5,53.16l-0.04-1.54L90.15,53.33z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000059293820878544981700000006083313341143976854_",
    cx: -330.201,
    cy: 436.4792,
    r: 1,
    gradientTransform: "matrix(0.3603 -34.0611 -61.4697 -0.6502 26985.127 -10933.209)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5BAB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#886FAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#AD94C6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000059293820878544981700000006083313341143976854_)"
    },
    d: " M8.06,34.9c-0.11,9.97,23.48,25.83,45.6,24.81c22.12-1.03,54.68-10.98,54.68-10.98l0.26-12.77l0.01-12.77 c0,0-32.36-10.63-54.43-12.13C32.09,9.56,8.16,25,8.06,34.9z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.34,48.74c0,0-1.13-14.55,0.27-25.55C108.61,23.19,109.86,37.48,108.34,48.74z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000142168943061296709000000001686666340048405691_",
    cx: -359.8073,
    cy: 439.6062,
    r: 1,
    gradientTransform: "matrix(0.0968 -9.1555 -8.1681 -0.0864 3632.053 -3221.1277)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#AC5F76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#9F587B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#80468D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#5C3B8F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000142168943061296709000000001686666340048405691_)"
    },
    d: " M17.92,48.41c0,0-4.28-14.17,1.44-27.55c0,0-11.16,6.82-11.3,14.05C7.93,41.41,17.92,48.41,17.92,48.41z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M19.53,20.93c-5.45,12.42-1.48,27.26-1.44,27.43l-0.34,0.1c-0.04-0.15-4.05-15.13,1.45-27.67L19.53,20.93z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M8.8,38.27l0.45-7.46C9.25,30.81,6.54,34.56,8.8,38.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153680867712190239340000012637150609152794032_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.6368,
    y1: 70.2089,
    x2: 13.3393,
    y2: 71.9841,
    gradientTransform: "matrix(0.8855 -0.4647 -0.4647 -0.8855 26.3788 105.0243)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4E601"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE751C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000153680867712190239340000012637150609152794032_)"
    },
    d: " M8.46,37.23c-0.21-1.39-0.23-2.8-0.06-4.2c0,0-3.52,0.78-3.66,2.06C4.61,36.37,8.46,37.23,8.46,37.23z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000093151064024569000170000000781142827068653985_",
    cx: -342.238,
    cy: 437.0042,
    r: 1,
    gradientTransform: "matrix(0.1711 -16.1735 -29.3344 -0.3103 12965.252 -5363.3608)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#8881BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#8376B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#7356A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#684696"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000093151064024569000170000000781142827068653985_)",
      enableBackground: "new"
    },
    d: " M86.82,54.42c0,0-6.76-21.62-1.68-37.89c9.21,2.22,23.46,6.67,23.46,6.67s-1.46,9.75-0.27,25.54 C108.34,48.74,97.64,52.59,86.82,54.42z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000080204074335597353940000002634183262912208574_",
    cx: -340.8725,
    cy: 437.7297,
    r: 1,
    gradientTransform: "matrix(0.1819 -17.198 -17.0294 -0.1801 7558.6758 -5747.8135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#8881BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#8376B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#7356A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#684696"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000080204074335597353940000002634183262912208574_)",
      enableBackground: "new"
    },
    d: " M24.02,35.91c0.6,8.99,11.13,15.52,20.37,16.03c9.24,0.51,14.98-7.98,14.82-17.1c-0.16-9.12-6.28-16.76-16.42-15.8 C33.64,19.88,23.36,25.91,24.02,35.91z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.55,35.89c0.6,8.99,11.13,15.52,20.37,16.03c9.24,0.51,14.98-7.98,14.83-17.1 c-0.16-9.12-6.28-16.76-16.42-15.8C32.17,19.86,21.89,25.9,22.55,35.89z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000008838160048439206980000008155988263972776099_",
    cx: -336.6429,
    cy: 436.8334,
    r: 1,
    gradientTransform: "matrix(0.2263 -21.3965 -35.3425 -0.3738 15541.0684 -7003.4624)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#715FA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#6B539E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#5C3B8F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000008838160048439206980000008155988263972776099_)"
    },
    d: " M21.52,35.88c0.6,8.99,11.13,15.52,20.37,16.03c9.24,0.51,14.98-7.98,14.83-17.1c-0.16-9.12-6.28-16.76-16.42-15.8 C31.14,19.85,20.86,25.89,21.52,35.88z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M24.83,35.32c0.4,8.07,8.69,12.2,15.91,12.6c7.23,0.4,11.69-6.27,11.57-13.44 c-0.12-7.17-4.9-13.15-12.81-12.42C32.33,22.72,24.4,26.89,24.83,35.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016757417076141799570000014038497818100580017_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.1839,
    y1: 49.6876,
    x2: 32.1299,
    y2: 62.1001,
    gradientTransform: "matrix(0.8855 -0.4647 -0.4647 -0.8855 26.3788 105.0243)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4E71F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7C5D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000016757417076141799570000014038497818100580017_)"
    },
    d: " M49.78,26.9c1.54,2.23,2.37,4.88,2.37,7.59c0.12,6.82-4.58,13.78-11.45,13.4c-2.35-0.13-4.65-0.7-6.79-1.68 c-4.21-1.94-7.55-5.57-7.91-10.93c-0.56-7.91,7.15-11.99,13.96-12.62C44.35,22.29,47.71,24.05,49.78,26.9z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M57.75,34.8l0,0.18l25.68,0.27l0-0.18L57.75,34.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M86.89,54.4l-0.17,0.05c-6.8-24.73-1.72-37.81-1.67-37.94l0.17,0.07C85.18,16.7,80.13,29.73,86.89,54.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.32,56.24l-0.15,0.1c-0.05-0.07-4.86-7.75-5.44-21.28l0.18,0C73.47,48.53,78.28,56.17,78.32,56.24z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M101.93,32.38l-11.09,0.24l-0.73-3.07l11.84,0.43L101.93,32.38z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000131327388998923947000000018290943259384227246_",
    cx: -377.6637,
    cy: 438.5562,
    r: 1,
    gradientTransform: "matrix(0.0672 -6.3535 -11.5236 -0.1219 5191.1514 -2309.8279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#715FA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#6B539E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#5C3B8F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000131327388998923947000000018290943259384227246_)"
    },
    d: " M108.59,46.63c0,0-0.94-11.11,0.13-21.97l4.96,0.72l-0.76,20.69L108.59,46.63z"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M110.77,46.34c-1.28-2.74-1.9-5.73-1.81-8.75c0.16-4.98,3.57-12.38,3.57-12.38l-3.81-0.55 c0,0-1.27,11.84-0.13,21.97L110.77,46.34z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M29.1,30.4c1.45-1.44,3.13-2.63,4.96-3.52l-0.97-1.74c0,0-3.18,1.3-4.32,3.77L29.1,30.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M42.99,45.43l2.51-1.4l0.82,1.44l-2.09,1.01L42.99,45.43z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000090288052159061621380000004241340585531145640_",
    cx: -350.978,
    cy: 438.5406,
    r: 1,
    gradientTransform: "matrix(0.1238 -11.7087 -11.5939 -0.1226 5148.1328 -4020.4309)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#8881BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#8376B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#7356A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#684696"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000090288052159061621380000004241340585531145640_)",
      enableBackground: "new"
    },
    d: " M22.38,51.34c0,0-7.06-14.2,0.32-32.53l-3.33,2.04c0,0-5.03,10.57-1.44,27.55L22.38,51.34z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178178190084179369420000012330257830606897558_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.113,
    y1: 37.9321,
    x2: 73.723,
    y2: 38.6808,
    gradientTransform: "matrix(0.8855 -0.4647 -0.4647 -0.8855 26.3788 105.0243)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#94C3EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#5D4E87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000178178190084179369420000012330257830606897558_)"
    },
    d: " M74.48,35.72c0.1,0,0.21,0.02,0.3,0.07c0.1,0.04,0.18,0.1,0.26,0.18c0.07,0.08,0.13,0.16,0.17,0.26c0.04,0.1,0.06,0.2,0.05,0.31 c0,0.21-0.09,0.41-0.24,0.56c-0.15,0.15-0.35,0.23-0.56,0.23c-0.21,0-0.41-0.09-0.56-0.24c-0.15-0.15-0.23-0.35-0.22-0.56 c0-0.1,0.02-0.21,0.06-0.3c0.04-0.1,0.1-0.18,0.17-0.26c0.07-0.07,0.16-0.13,0.26-0.17S74.38,35.72,74.48,35.72z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000065773074812609572590000014902501932129314237_",
    cx: -906.1058,
    cy: 483.0872,
    r: 1,
    gradientTransform: "matrix(6.681932e-03 -0.6318 -0.6256 -6.616432e-03 383.2925 -532.5726)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#8881BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#8376B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#7356A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#684696"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000065773074812609572590000014902501932129314237_)"
    },
    d: " M74.48,35.88c0.17,0.01,0.32,0.08,0.44,0.2c0.11,0.12,0.18,0.28,0.18,0.45c0,0.17-0.07,0.33-0.19,0.45 c-0.12,0.12-0.28,0.19-0.44,0.19c-0.17-0.01-0.32-0.08-0.44-0.2c-0.11-0.12-0.18-0.28-0.18-0.45c0-0.17,0.07-0.33,0.19-0.45 S74.31,35.89,74.48,35.88z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074411458840416351490000015087688973769526186_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.6822,
    y1: 39.7777,
    x2: 70.2892,
    y2: 40.5278,
    gradientTransform: "matrix(0.8855 -0.4647 -0.4647 -0.8855 26.3788 105.0243)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#94C3EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#5D4E87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000074411458840416351490000015087688973769526186_)"
    },
    d: " M70.58,35.68c0.21,0.01,0.41,0.09,0.55,0.25c0.14,0.15,0.22,0.36,0.22,0.57c0,0.21-0.09,0.41-0.24,0.56 c-0.15,0.15-0.35,0.23-0.56,0.23c-0.21-0.01-0.41-0.09-0.55-0.25c-0.14-0.15-0.22-0.35-0.22-0.56c0-0.1,0.02-0.21,0.06-0.3 c0.04-0.1,0.1-0.18,0.17-0.26c0.07-0.07,0.16-0.13,0.26-0.17C70.37,35.7,70.48,35.68,70.58,35.68z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000153697447093936766500000012846181839959262347_",
    cx: -906.1058,
    cy: 483.0874,
    r: 1,
    gradientTransform: "matrix(6.681932e-03 -0.6318 -0.6256 -6.616391e-03 379.3801 -532.6144)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#8881BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#8376B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#7356A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#684696"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000153697447093936766500000012846181839959262347_)"
    },
    d: " M70.58,35.84c0.17,0.01,0.32,0.08,0.44,0.2c0.12,0.12,0.18,0.28,0.18,0.45c0,0.17-0.07,0.33-0.19,0.45 c-0.12,0.12-0.28,0.19-0.44,0.19c-0.08,0-0.16-0.02-0.24-0.05c-0.08-0.03-0.14-0.08-0.2-0.14c-0.06-0.06-0.1-0.13-0.13-0.21 c-0.03-0.08-0.04-0.16-0.04-0.24c0-0.08,0.01-0.17,0.04-0.24c0.03-0.08,0.08-0.15,0.14-0.21c0.06-0.06,0.13-0.11,0.2-0.14 C70.41,35.86,70.5,35.84,70.58,35.84z"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M44.66,49.37c0-0.44-0.35-0.8-0.78-0.81c-0.44,0-0.79,0.35-0.8,0.79c-0.01,0.44,0.34,0.8,0.78,0.81 C44.3,50.16,44.66,49.81,44.66,49.37z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000058555478789970626690000005577542352096691890_",
    cx: -906.1058,
    cy: 483.0874,
    r: 1,
    gradientTransform: "matrix(6.681932e-03 -0.6318 -0.6256 -6.616391e-03 352.591 -519.7177)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5BAB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#886FAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000058555478789970626690000005577542352096691890_)"
    },
    d: " M43.87,48.72c0.17,0.01,0.32,0.08,0.44,0.2c0.11,0.12,0.18,0.28,0.18,0.45c0,0.17-0.07,0.33-0.19,0.45 C44.19,49.93,44.03,50,43.86,50c-0.17-0.01-0.32-0.08-0.44-0.2c-0.11-0.12-0.18-0.28-0.18-0.45c0-0.08,0.01-0.17,0.04-0.24 c0.03-0.08,0.08-0.15,0.14-0.21c0.06-0.06,0.13-0.11,0.2-0.14C43.71,48.73,43.79,48.72,43.87,48.72z"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M32.71,47.04c0.21,0,0.41,0.09,0.56,0.24c0.15,0.15,0.23,0.35,0.22,0.56c0,0.1-0.02,0.21-0.06,0.3 c-0.04,0.1-0.1,0.18-0.17,0.26c-0.07,0.07-0.16,0.13-0.26,0.17c-0.1,0.04-0.2,0.06-0.31,0.06c-0.1,0-0.21-0.02-0.3-0.07 c-0.1-0.04-0.18-0.1-0.25-0.18c-0.07-0.08-0.13-0.16-0.17-0.26c-0.04-0.1-0.06-0.2-0.05-0.31c0-0.21,0.09-0.41,0.23-0.56 C32.3,47.12,32.5,47.04,32.71,47.04z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000130617993226431713030000011283187509233583019_",
    cx: -906.1058,
    cy: 483.0872,
    r: 1,
    gradientTransform: "matrix(6.681932e-03 -0.6318 -0.6256 -6.616432e-03 341.3889 -521.2406)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5BAB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#886FAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000130617993226431713030000011283187509233583019_)"
    },
    d: " M32.71,47.21c0.17,0.01,0.32,0.08,0.44,0.2c0.12,0.12,0.18,0.28,0.18,0.45c0,0.17-0.07,0.33-0.19,0.45 c-0.12,0.12-0.28,0.19-0.44,0.19c-0.17-0.01-0.32-0.08-0.44-0.2c-0.12-0.12-0.18-0.28-0.18-0.45c0-0.17,0.07-0.33,0.19-0.45 C32.38,47.28,32.54,47.21,32.71,47.21z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M52.79,41.17c0.1,0,0.21,0.02,0.3,0.07c0.1,0.04,0.18,0.1,0.26,0.18c0.07,0.08,0.13,0.16,0.17,0.26 c0.04,0.1,0.06,0.2,0.06,0.31c0,0.21-0.09,0.41-0.24,0.56c-0.15,0.15-0.35,0.23-0.56,0.23c-0.21,0-0.41-0.09-0.56-0.24 c-0.15-0.15-0.23-0.35-0.22-0.57c0-0.1,0.02-0.21,0.06-0.3c0.04-0.1,0.1-0.18,0.17-0.26c0.07-0.07,0.16-0.13,0.26-0.17 C52.58,41.19,52.68,41.17,52.79,41.17z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000165935851713002005060000011892189982502286268_",
    cx: -906.1058,
    cy: 483.0872,
    r: 1,
    gradientTransform: "matrix(6.681932e-03 -0.6318 -0.6256 -6.616432e-03 361.5292 -527.1165)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5BAB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#886FAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000165935851713002005060000011892189982502286268_)"
    },
    d: " M52.79,41.34c0.17,0.01,0.32,0.08,0.44,0.2c0.11,0.12,0.18,0.28,0.18,0.45c0,0.17-0.07,0.33-0.19,0.44 c-0.12,0.12-0.28,0.19-0.44,0.19c-0.17-0.01-0.32-0.08-0.44-0.2c-0.11-0.12-0.18-0.28-0.18-0.45c0-0.17,0.07-0.33,0.19-0.44 S52.62,41.35,52.79,41.34z"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M53.87,28.8c0.1,0,0.21,0.02,0.3,0.06c0.1,0.04,0.18,0.1,0.26,0.18c0.07,0.07,0.13,0.16,0.17,0.26 c0.04,0.1,0.06,0.2,0.06,0.31c0,0.21-0.09,0.41-0.24,0.56c-0.15,0.15-0.35,0.23-0.56,0.23c-0.21,0-0.41-0.09-0.56-0.24 c-0.15-0.15-0.23-0.35-0.22-0.57c0-0.1,0.02-0.21,0.06-0.3c0.04-0.1,0.1-0.18,0.17-0.26c0.07-0.07,0.16-0.13,0.26-0.17 C53.66,28.82,53.76,28.8,53.87,28.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000093867561711651771330000001767827112511840677_",
    cx: -906.1058,
    cy: 483.0874,
    r: 1,
    gradientTransform: "matrix(6.681932e-03 -0.6318 -0.6256 -6.616391e-03 362.6158 -539.5026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5BAB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#886FAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000093867561711651771330000001767827112511840677_)"
    },
    d: " M53.87,28.97c0.17,0.01,0.32,0.08,0.44,0.2c0.12,0.12,0.18,0.28,0.18,0.45c0,0.17-0.07,0.33-0.19,0.45 c-0.12,0.12-0.28,0.19-0.44,0.19c-0.08,0-0.16-0.02-0.24-0.05c-0.08-0.03-0.14-0.08-0.2-0.14c-0.06-0.06-0.1-0.13-0.13-0.21 c-0.03-0.08-0.04-0.16-0.04-0.24c0-0.08,0.01-0.17,0.04-0.24c0.03-0.08,0.08-0.15,0.14-0.21c0.06-0.06,0.13-0.11,0.2-0.14 C53.7,28.99,53.78,28.97,53.87,28.97z"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M47.37,21.15c0-0.44-0.34-0.8-0.78-0.81c-0.44,0-0.79,0.35-0.8,0.79c0,0.44,0.34,0.8,0.78,0.81 C47,21.95,47.36,21.59,47.37,21.15z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000100363477120912120640000001196460343618329783_",
    cx: -906.1058,
    cy: 483.0872,
    r: 1,
    gradientTransform: "matrix(6.681932e-03 -0.6318 -0.6256 -6.616432e-03 355.309 -547.9736)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5BAB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#886FAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000100363477120912120640000001196460343618329783_)"
    },
    d: " M46.58,20.5c0.17,0.01,0.32,0.08,0.44,0.2c0.11,0.12,0.18,0.28,0.18,0.45c0,0.17-0.07,0.33-0.19,0.44 c-0.12,0.12-0.28,0.19-0.44,0.19c-0.17-0.01-0.32-0.08-0.44-0.2c-0.12-0.12-0.18-0.28-0.18-0.45c0-0.17,0.07-0.33,0.19-0.45 C46.26,20.57,46.42,20.51,46.58,20.5z"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M32.57,21.48c0.1,0,0.21,0.02,0.3,0.06c0.1,0.04,0.18,0.1,0.25,0.18c0.07,0.07,0.13,0.16,0.17,0.26 c0.04,0.1,0.06,0.2,0.06,0.31c0,0.21-0.09,0.41-0.24,0.56c-0.15,0.15-0.35,0.23-0.56,0.23c-0.21,0-0.41-0.09-0.56-0.24 c-0.15-0.15-0.23-0.35-0.22-0.56c0-0.1,0.02-0.21,0.06-0.3c0.04-0.1,0.1-0.18,0.17-0.26c0.07-0.07,0.16-0.13,0.26-0.17 C32.36,21.5,32.47,21.48,32.57,21.48z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000137132239383359465730000005165880298109998772_",
    cx: -906.1058,
    cy: 483.0872,
    r: 1,
    gradientTransform: "matrix(6.681932e-03 -0.6318 -0.6256 -6.616432e-03 341.2481 -546.836)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5BAB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#886FAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000137132239383359465730000005165880298109998772_)"
    },
    d: " M32.57,21.64c0.17,0.01,0.32,0.08,0.44,0.2c0.11,0.12,0.18,0.28,0.18,0.45c0,0.17-0.07,0.33-0.19,0.45 c-0.12,0.12-0.28,0.19-0.44,0.19c-0.17-0.01-0.32-0.08-0.44-0.2c-0.11-0.12-0.18-0.28-0.18-0.45c0-0.17,0.07-0.33,0.19-0.45 C32.24,21.71,32.4,21.64,32.57,21.64z"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M25.28,27.7c0.1,0,0.21,0.02,0.3,0.07c0.1,0.04,0.18,0.1,0.26,0.18c0.07,0.08,0.13,0.16,0.17,0.26 c0.04,0.1,0.06,0.2,0.06,0.31c0,0.21-0.09,0.41-0.24,0.56c-0.15,0.15-0.35,0.23-0.56,0.23c-0.21,0-0.41-0.09-0.56-0.24 c-0.15-0.15-0.23-0.35-0.22-0.57c0-0.1,0.02-0.21,0.06-0.3c0.04-0.1,0.1-0.18,0.17-0.26c0.07-0.07,0.16-0.13,0.26-0.17 C25.08,27.72,25.18,27.7,25.28,27.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000137126597228164012500000015191026173266793138_",
    cx: -906.1058,
    cy: 483.0872,
    r: 1,
    gradientTransform: "matrix(6.681932e-03 -0.6318 -0.6256 -6.616432e-03 333.9399 -540.6046)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5BAB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#886FAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000137126597228164012500000015191026173266793138_)"
    },
    d: " M25.28,27.87c0.17,0.01,0.32,0.08,0.44,0.2c0.11,0.12,0.18,0.28,0.18,0.45c0,0.17-0.07,0.33-0.19,0.45 c-0.12,0.12-0.28,0.19-0.44,0.19c-0.17-0.01-0.32-0.08-0.44-0.2c-0.11-0.12-0.18-0.28-0.18-0.45c0-0.17,0.07-0.33,0.19-0.45 C24.96,27.94,25.11,27.88,25.28,27.87z"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M24.04,38.3c0.21,0,0.41,0.09,0.56,0.24c0.15,0.15,0.23,0.35,0.22,0.57c0,0.1-0.02,0.21-0.06,0.3 c-0.04,0.1-0.1,0.18-0.17,0.26c-0.07,0.07-0.16,0.13-0.26,0.17c-0.1,0.04-0.2,0.06-0.3,0.06c-0.1,0-0.21-0.02-0.3-0.07 c-0.1-0.04-0.18-0.1-0.26-0.18c-0.07-0.08-0.13-0.16-0.17-0.26c-0.04-0.1-0.06-0.2-0.06-0.31c0-0.21,0.09-0.41,0.24-0.56 C23.63,38.38,23.83,38.3,24.04,38.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000120533652346371081930000015166181860867804066_",
    cx: -906.1058,
    cy: 483.0874,
    r: 1,
    gradientTransform: "matrix(6.681932e-03 -0.6318 -0.6256 -6.616391e-03 332.689 -529.9977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5BAB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#886FAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000120533652346371081930000015166181860867804066_)"
    },
    d: " M24.04,38.47c0.08,0,0.17,0.02,0.24,0.05c0.08,0.03,0.14,0.08,0.2,0.14c0.06,0.06,0.1,0.13,0.13,0.21 c0.03,0.08,0.04,0.16,0.04,0.24c0,0.08-0.01,0.17-0.04,0.24c-0.03,0.08-0.08,0.15-0.14,0.21c-0.06,0.06-0.13,0.11-0.21,0.14 c-0.08,0.03-0.16,0.05-0.24,0.05c-0.17-0.01-0.32-0.08-0.44-0.2c-0.11-0.12-0.18-0.28-0.18-0.45c0-0.17,0.07-0.33,0.19-0.44 C23.71,38.54,23.87,38.47,24.04,38.47z"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M118.69,52.8l0.01-0.59l-21.23,0.36l0.02,0.58L118.69,52.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M97.85,18.69l-0.03,0.58l21.22,0.62l0-0.4L97.85,18.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117669662251195973430000008471788707373798055_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.7317,
    y1: 23.2611,
    x2: 87.4024,
    y2: 39.0524,
    gradientTransform: "matrix(0.8855 -0.4647 -0.4647 -0.8855 26.3788 105.0243)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A53517"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C73735"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000117669662251195973430000008471788707373798055_)"
    },
    d: " M85.62,30.15l0.02-2.11l33.29,2.46l-0.01,1.47L85.62,30.15z"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M85.62,30.15l7.36,1.54l25.94,0.27L85.62,30.15z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M86.66,28.12l21.95-4.92l-0.33,5.09l5.29,0.12l-0.02,1.7L86.66,28.12z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M28.72,53.01c0,0-2.29,0.18-3.69-1.3l0.07-1.2c1.24,0.57,2.45,1.2,3.63,1.89L28.72,53.01z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M79.52,16.48l-9.88-2.31l0.01-0.61l9.88,2.19L79.52,16.48z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023966282649527666330000011801551647043389119_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.9236,
    y1: 76.1365,
    x2: 52.8703,
    y2: 77.8955,
    gradientTransform: "matrix(0.8855 -0.4647 -0.4647 -0.8855 26.3788 105.0243)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4E601"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE751C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000023966282649527666330000011801551647043389119_)"
    },
    d: " M35.22,13.46c0,0-0.72-3.73,3.56-0.97L35.22,13.46z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094591773311755688130000010928026463143571644_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.0223,
    y1: 36.5992,
    x2: 30.9125,
    y2: 38.2528,
    gradientTransform: "matrix(0.8855 -0.4647 -0.4647 -0.8855 26.3788 105.0243)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4E601"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE751C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000094591773311755688130000010928026463143571644_)"
    },
    d: " M34.27,56.77c0,0,0.97,3.46,3.4,1.03L34.27,56.77z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M108.02,45.13c0,0-29.45,9.29-51.39,12.82l0.45,0.94c0,0,33.67-4.16,51.23-10.66L108.02,45.13z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M67.39,13.81l-6.1-1.17l0.01-0.58l6.1,1.17L67.39,13.81z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M76.9,52.66c0,0-2.74-6.4-3.25-12.47C73.64,40.19,74.91,46.24,76.9,52.66z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M60.14,34.62l22.51,0.09C82.65,34.7,74.5,34.22,60.14,34.62z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M85.94,49.81c0,0-4.24-15.21-1.27-29.71C84.69,20.09,81.95,30.83,85.94,49.81z"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M26.87,45.79c0,0,0.84-2.06-2.96-3.31C24.76,43.71,25.75,44.82,26.87,45.79z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M56.63,33c0,0-0.2-4.96-5.46-10.89C51.15,22.11,55.96,25.68,56.63,33z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M52.3,34.83c0,0,2.35-4.31-1.85-7.31C50.46,27.52,52.46,29.84,52.3,34.83z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M61.93,35.78c0.17,0.26,0.41,0.75,0.8,0.68c0.17-0.06,0.34-0.12,0.51-0.2c0.15-0.05,0.31-0.08,0.47-0.09 c0.26-0.02,0.51-0.12,0.72-0.28c0.13-0.12,0-0.24-0.12-0.32c-0.12-0.1-0.27-0.17-0.42-0.19c-0.2,0-0.41-0.03-0.61-0.08 c-0.08-0.02-0.15-0.08-0.23-0.1c-0.11-0.01-0.21-0.01-0.32,0c-0.18,0-0.35,0.06-0.49,0.17C62.09,35.46,61.98,35.61,61.93,35.78z "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M65.14,36.86c-0.05,0.02-0.09,0.02-0.14,0.01c-0.05-0.01-0.09-0.04-0.12-0.07c0-0.39,0.76-0.51,0.9-0.15 c0.17,0.42-0.4,0.46-0.65,0.33L65.14,36.86z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M69.86,43.98c-0.09-0.2-0.22-0.37-0.17-0.59c0.05-0.18,0.15-0.34,0.3-0.46c0.18-0.14,0.4-0.23,0.62-0.28 c0.1-0.05,0.21-0.07,0.32-0.05c0.45,0.12,0.75,0.65,0.88,1.05c0.08,0.23,0.14,0.47,0.17,0.71c0,0.17,0.04,0.34,0.06,0.51 c0.04,0.13,0.06,0.28,0.04,0.42c-0.05,0.12-0.11,0.22-0.19,0.32c-0.1,0.13-0.22,0.24-0.37,0.32c-0.15,0.07-0.31,0.11-0.47,0.11 c-0.58-0.03-1.04-0.74-1.27-1.22C69.6,44.41,69.37,43.79,69.86,43.98z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M69.09,42.13c0.16,0.06,0.21,0.1,0.32-0.03c0.03-0.05,0.05-0.11,0.05-0.17c0-0.06,0-0.12-0.02-0.17 c-0.07-0.21-0.37-0.47-0.58-0.33c-0.1,0.08-0.29,0.26-0.33,0.38c0.01,0.14,0.07,0.27,0.18,0.37c0.1,0.1,0.23,0.16,0.37,0.17 L69.09,42.13z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M74.86,34.5c0.09,0.03,0.18,0.04,0.27,0.03c0.22,0,0.45,0.01,0.68,0.01c0.42,0,0.85,0.07,1.28,0.08 c0.31,0,0.62-0.03,0.92-0.09c0.16-0.02,0.32-0.05,0.47-0.09c0-0.03-0.09-0.04-0.12-0.06c-0.12-0.06-0.25-0.09-0.36-0.15 c-0.25-0.14-0.52-0.29-0.78-0.41c-0.05-0.02-0.1-0.04-0.15-0.07c-0.05-0.04-0.1-0.1-0.16-0.15c-0.09-0.09-0.2-0.16-0.32-0.21 c-0.28-0.1-0.58-0.14-0.87-0.11c-0.1,0-0.19,0.03-0.29,0.03c-0.11,0-0.21,0-0.32,0.02c-0.22,0.04-0.43,0.13-0.63,0.25 c-0.23,0.13-0.62,0.28-0.69,0.57c-0.03,0.14,0.12,0.2,0.24,0.22c0.12,0.02,0.29,0.03,0.44,0.05 C74.62,34.44,74.91,34.52,74.86,34.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M72.85,34.17c-0.11-0.07-0.32-0.15-0.27-0.32c0.05-0.17,0.26-0.16,0.39-0.14c0.3,0.05,0,0.43-0.21,0.4 L72.85,34.17z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M74.74,31.27c0.1,0.07,0.22,0.1,0.35,0.08c0.08-0.01,0.15-0.06,0.2-0.12c0.05-0.07,0.07-0.15,0.06-0.23 c0-0.27-0.05-0.46-0.32-0.52c-0.1-0.01-0.2,0.01-0.3,0.04c-0.09,0.03-0.18,0.09-0.25,0.16c-0.05,0.06-0.09,0.14-0.09,0.22 c0,0.17,0.11,0.25,0.24,0.32L74.74,31.27z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M83.28,25.21c-0.2-0.41-0.35-0.84-0.45-1.29c-0.04-0.39-0.07-0.79-0.07-1.19 c-0.08-0.54-0.2-1.08-0.35-1.61c-0.13-0.46-0.15-0.95-0.05-1.43c0.04-0.19,0.13-0.37,0.24-0.53c0.12-0.16,0.26-0.29,0.43-0.39 c0.22-0.1,0.45-0.17,0.68-0.19c0.11,0,0.22-0.02,0.32-0.03c0.06-0.02,0.13-0.03,0.2-0.03c0.11,0,0.11,0.05,0.1,0.15 c0.01,0.17-0.03,0.35-0.13,0.5c-0.14,0.27-0.24,0.56-0.28,0.86c-0.05,0.29-0.12,0.56-0.16,0.86l-0.11,0.85 c-0.04,0.24-0.08,0.49-0.12,0.73c-0.04,0.25-0.04,0.49-0.06,0.73c-0.02,0.24,0,0.4-0.01,0.61c0,0.13-0.02,0.25-0.03,0.38 c0,0.1-0.01,0.2-0.03,0.3c-0.01,0.09-0.01,0.19,0,0.29C83.4,24.91,83.35,25.06,83.28,25.21z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M81.55,22.58c0.05,0.06,0.09,0.15,0.17,0.16c0.04,0.01,0.08,0.01,0.12,0c0.18-0.04,0.19-0.34,0.19-0.49 c0.02-0.43-0.12-0.86-0.4-1.19c-0.1-0.11-0.22-0.2-0.35-0.26s-0.28-0.08-0.43-0.07c-0.38,0.08-0.6,0.48-0.68,0.84 c-0.08,0.35-0.1,0.79,0.16,1.05c0.08,0.1,0.2,0.16,0.32,0.18c0.1,0,0.2-0.01,0.3-0.03c0.14,0,0.25,0.07,0.38,0 C81.42,22.74,81.5,22.67,81.55,22.58z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M81.6,20.12c-0.04,0.01-0.08,0.02-0.11,0.01c-0.04-0.01-0.07-0.03-0.1-0.06c-0.04-0.02-0.07-0.06-0.08-0.1 c-0.02-0.04-0.02-0.09,0-0.13c0.01-0.04,0.03-0.07,0.05-0.1c0.02-0.03,0.05-0.05,0.09-0.07c0.03-0.02,0.07-0.03,0.11-0.03 c0.04,0,0.08,0.01,0.11,0.02c0.05,0.03,0.08,0.07,0.11,0.11c0.03,0.05,0.04,0.1,0.04,0.15c0,0.06-0.01,0.11-0.05,0.16 c-0.03,0.05-0.08,0.08-0.14,0.09L81.6,20.12z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M72.82,16.86c0.04,0.14,0.13,0.25,0.25,0.32c0.03,0.03,0.06,0.04,0.1,0.05c0.04,0.01,0.08,0,0.11-0.02 c0.23-0.12,0.4-0.32,0.49-0.56c0.03-0.08,0.04-0.17,0.03-0.25c-0.01-0.09-0.03-0.17-0.07-0.24c-0.09-0.12-0.2-0.23-0.32-0.32 c-0.1-0.09-0.2-0.17-0.32-0.24c-0.08-0.08-0.17-0.13-0.28-0.15c-0.11-0.02-0.22,0-0.32,0.05c-0.1,0.07-0.18,0.15-0.24,0.26 c-0.06,0.1-0.09,0.22-0.09,0.34c0.01,0.16,0.07,0.32,0.15,0.45C72.42,16.68,72.47,16.82,72.82,16.86z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M73.73,17.7c0.01-0.12,0.04-0.24,0.1-0.35c0.05,0,0.08-0.07,0.15-0.04c0.06,0.03,0.06,0.19,0.06,0.26 c0,0.09-0.04,0.18-0.11,0.25c-0.03,0.02-0.13,0.12-0.14,0.04L73.73,17.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M80.72,28.87c0.14,0.08,0.29,0.17,0.45,0.03c0.06-0.07,0.09-0.16,0.1-0.25c0.01-0.09-0.01-0.18-0.06-0.26 c-0.03-0.08-0.08-0.18-0.17-0.19c-0.09-0.01-0.2,0-0.29,0c-0.23,0-0.39-0.24-0.61-0.04c-0.05,0.05-0.09,0.11-0.11,0.18 C80,28.41,79.99,28.48,80,28.55c0.04,0.23,0.28,0.36,0.48,0.44L80.72,28.87z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M88.94,47.59c0.05,0.26,0.18,0.5,0.37,0.69l0.1,0c0.08,0.04,0.17,0.06,0.27,0.06 c0.09,0,0.18-0.02,0.27-0.06c0.52-0.27,0.46-0.81,0.47-1.31c0-0.5,0.07-1.21-0.66-0.97c-0.32,0.11-0.88,0.26-1.09,0.57 c-0.11,0.17-0.06,0.25,0,0.41c0.06,0.23,0.15,0.45,0.29,0.65L88.94,47.59z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M89.82,41.5c-0.14-0.08-0.42-0.21-0.44-0.42c-0.02-0.21,0.08-0.23,0.17-0.35 c0.19-0.27,0.45-0.52,0.78-0.25c0.08,0.08,0.14,0.17,0.18,0.28c0.04,0.1,0.05,0.22,0.04,0.33c-0.03,0.18-0.25,0.47-0.45,0.41 L89.82,41.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M44.15,15.57c0.4,0.2,0.42,0.22,0.83,0.11c0.32-0.05,0.63-0.17,0.89-0.37c0.32-0.32,0.24-0.72,0.33-1.1 c0.05-0.12,0.06-0.25,0.05-0.38c-0.02-0.13-0.07-0.25-0.15-0.35c-0.21-0.27-0.47-0.5-0.77-0.67c-0.48-0.25-1.02-0.39-1.56-0.41 c-0.54-0.02-1.09,0.08-1.59,0.29c-0.61,0.27-1.31,0.67-1.51,1.36c-0.09,0.29-0.1,0.6-0.03,0.89c0.07,0.3,0.22,0.57,0.43,0.78 c0.23,0.2,0.5,0.34,0.79,0.41c0.29,0.07,0.6,0.07,0.89,0l0.41-0.11c0.18-0.02,0.36-0.01,0.54,0.01 C43.87,16.01,44.04,15.91,44.15,15.57z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M45.69,16.69c0.33-0.38,0.26-0.32,0.65-0.38c0.17-0.02,0.21-0.09,0.37-0.05c0.11,0.04,0.2,0.12,0.27,0.22 c0.07,0.1,0.1,0.21,0.1,0.33c0,0.16-0.33,0.41-0.45,0.48c-0.07,0.04-0.16,0.06-0.24,0.06c-0.08-0.01-0.17-0.04-0.23-0.09 L45.69,16.69z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M45.19,55.53c0.32,0.08,0.72,0.2,0.96-0.17c0.16-0.25,0.01-0.64-0.16-0.87c-0.32-0.36-0.75-0.62-1.23-0.72 c-0.42-0.06-0.88,0.45-0.93,0.84c-0.11,0.8,1.14,1.23,1.73,1.3L45.19,55.53z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M48.83,56.12c-0.09,0.04-0.37,0.23-0.48,0.2c-0.05,0-0.06-0.08-0.11-0.11c-0.08-0.04-0.15-0.1-0.2-0.17 c-0.05-0.07-0.09-0.15-0.12-0.23c-0.04-0.18-0.02-0.36,0.06-0.52c0.08-0.16,0.21-0.3,0.37-0.38c0.1-0.07,0.21-0.1,0.33-0.09 c0.12,0.01,0.23,0.07,0.31,0.15c0.11,0.12,0.17,0.27,0.17,0.43c0,0.16-0.05,0.31-0.16,0.43L48.83,56.12z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M91.5,21.24c0.56,0.24,1.19,0.29,1.79,0.14c0.39-0.07,0.9-0.12,1.08-0.54c0.41-0.98-1.67-1.76-2.34-1.95 c-0.58-0.17-1.19-0.21-1.78-0.13c-0.35,0.06-1.05,0.33-1.23,0.67c-0.24,0.44,0.04,0.96,0.38,1.22c0.8,0.65,1.83,0.48,2.74,0.79 L91.5,21.24z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M91.36,21.74c0.02,0.24,0.06,0.48,0.15,0.71c0.07,0.11,0.18,0.28,0.32,0.32c0.09,0.01,0.18-0.01,0.26-0.04 c0.08-0.04,0.15-0.09,0.21-0.16c0.05-0.04,0.08-0.1,0.1-0.16c0.02-0.06,0.02-0.13,0.01-0.19c-0.03-0.09-0.16-0.17-0.23-0.22 c-0.14-0.1-0.29-0.18-0.44-0.25c-0.07-0.04-0.15-0.07-0.22-0.1c-0.13-0.03-0.17,0.06-0.27,0.09L91.36,21.74z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M96.46,22.35l0.16-0.32c0.13,0.02,0.28-0.02,0.36,0.1c0.05,0.13,0.06,0.28,0.02,0.42 c-0.02,0.07-0.06,0.13-0.12,0.17c-0.06,0.04-0.13,0.06-0.2,0.06c-0.17,0-0.24-0.17-0.27-0.32L96.46,22.35z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M103.18,37.73c0.07,0.04,0.14,0.05,0.22,0.04c0.07-0.01,0.14-0.04,0.2-0.1c0.09-0.08,0.16-0.2,0.17-0.32 c0.01-0.12-0.02-0.25-0.1-0.35c-0.22-0.29-0.72-0.62-1.1-0.54c-0.24,0.05-0.53,0.36-0.38,0.61c0.07,0.14,0.17,0.28,0.27,0.4 c0.19,0.16,0.43,0.25,0.68,0.26L103.18,37.73z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M22.81,24.66c0.1,0.11,0.14,0.17,0.28,0.2c0.16,0.05,0.33,0.03,0.48-0.04c0.3-0.26,0.51-0.61,0.58-1 c0.04-0.14,0.05-0.28,0.02-0.42c-0.03-0.14-0.08-0.27-0.17-0.39c-0.09-0.14-0.21-0.26-0.35-0.35c-0.14-0.09-0.3-0.15-0.46-0.18 c-0.16-0.04-0.33-0.03-0.48,0.03c-0.15,0.06-0.29,0.17-0.38,0.3c-0.21,0.27-0.36,0.58-0.44,0.91c-0.02,0.13-0.02,0.26,0.02,0.38 c0.04,0.12,0.1,0.24,0.19,0.33C22.29,24.63,22.58,24.89,22.81,24.66z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M23.98,22.09c-0.1,0-0.21,0-0.23-0.1c0-0.09,0.01-0.17,0.05-0.25c0.03-0.08,0.08-0.15,0.14-0.21 c0.1-0.09,0.23-0.13,0.36-0.13c0.09,0.03,0.16,0.09,0.21,0.17c0.04,0.05,0.07,0.12,0.07,0.18c0,0.07-0.01,0.13-0.05,0.19 c-0.05,0.08-0.16,0.28-0.28,0.25L23.98,22.09z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M11.82,29.85c0.14,0.02,0.29-0.01,0.41-0.09c0.22-0.14,0.41-0.33,0.55-0.55c0.2-0.28,0.3-0.62,0.3-0.96 c-0.03-0.13-0.09-0.24-0.18-0.33c-0.09-0.09-0.2-0.15-0.33-0.18c-0.31-0.03-0.62,0.04-0.88,0.22c-0.23,0.16-0.41,0.38-0.54,0.62 c-0.13,0.25-0.19,0.52-0.19,0.8C11,30.01,11.93,30.04,11.82,29.85z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M14.03,27.15c-0.06,0.07-0.14,0.11-0.23,0.14c-0.04-0.09-0.14-0.12-0.18-0.22 c-0.03-0.1-0.01-0.21,0.04-0.3c0.03-0.06,0.08-0.11,0.13-0.15c0.06-0.04,0.12-0.06,0.19-0.06c0.16,0,0.2,0.06,0.26,0.19 c0.07,0.13,0.07,0.12,0,0.22c-0.04,0.07-0.09,0.13-0.14,0.19L14.03,27.15z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097480799337850489900000014017076772555086495_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.9711,
    y1: 21.6658,
    x2: 77.3631,
    y2: 22.5318,
    gradientTransform: "matrix(0.8855 -0.4647 -0.4647 -0.8855 26.3788 105.0243)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#94C3EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#5D4E87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000097480799337850489900000014017076772555086495_)"
    },
    d: " M85.33,48.46c0.5,0.01,0.91,0.31,0.91,0.68c0,0.37-0.42,0.66-0.92,0.66c-0.5-0.01-0.91-0.31-0.9-0.68 C84.41,48.75,84.82,48.46,85.33,48.46z"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M85.33,48.61c0.4,0,0.72,0.24,0.71,0.53c0,0.29-0.33,0.52-0.72,0.52c-0.4,0-0.72-0.24-0.71-0.53 C84.61,48.83,84.93,48.6,85.33,48.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143609357780665920890000009764365296172554388_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.913,
    y1: 45.9979,
    x2: 88.3052,
    y2: 46.864,
    gradientTransform: "matrix(0.8855 -0.4647 -0.4647 -0.8855 26.3788 105.0243)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#94C3EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#5D4E87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000143609357780665920890000009764365296172554388_)"
    },
    d: " M83.71,21.76c0.22-0.02,0.44,0.05,0.6,0.19c0.17,0.14,0.28,0.34,0.3,0.56c-0.03,0.22-0.14,0.42-0.31,0.55 c-0.17,0.14-0.39,0.2-0.61,0.18c-0.22,0.02-0.44-0.05-0.61-0.19c-0.17-0.14-0.28-0.34-0.3-0.56c0.03-0.22,0.14-0.42,0.31-0.55 C83.27,21.8,83.49,21.74,83.71,21.76z"
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M83.71,21.92c0.17-0.01,0.34,0.04,0.48,0.15c0.13,0.11,0.22,0.27,0.24,0.44c-0.02,0.17-0.11,0.33-0.25,0.43 c-0.14,0.11-0.31,0.16-0.48,0.14c-0.17,0.01-0.34-0.04-0.48-0.15c-0.13-0.11-0.22-0.27-0.24-0.44c0.02-0.17,0.11-0.33,0.25-0.43 C83.36,21.95,83.53,21.9,83.71,21.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160177461844320997050000003317494123971604403_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.7871,
    y1: 34.9173,
    x2: 82.1791,
    y2: 35.783,
    gradientTransform: "matrix(0.8855 -0.4647 -0.4647 -0.8855 26.3788 105.0243)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#94C3EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#5D4E87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160177461844320997050000003317494123971604403_)"
    },
    d: "M84.34,35.17 c0.01-0.51-0.4-0.93-0.9-0.93c-0.51-0.01-0.92,0.4-0.92,0.91c-0.01,0.51,0.4,0.93,0.91,0.93C83.92,36.09,84.34,35.68,84.34,35.17z "
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M83.44,34.43c0.19,0,0.37,0.08,0.51,0.22s0.21,0.32,0.2,0.51c0,0.19-0.08,0.38-0.21,0.51 c-0.14,0.14-0.32,0.21-0.51,0.21c-0.19,0-0.37-0.08-0.51-0.22c-0.13-0.14-0.21-0.32-0.2-0.51c0-0.19,0.08-0.38,0.21-0.51 C83.06,34.51,83.24,34.43,83.44,34.43z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000100379092861715070150000011696889131383332534_",
    cx: -381.5927,
    cy: 466.2611,
    r: 1,
    gradientTransform: "matrix(-1.8843 -5.0434 -4.9807 1.8609 1686.7729 -2757.2441)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2F519F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#2C4C9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#233A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#242F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#1B2140"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#101325"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#06080F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#020304"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020203"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100379092861715070150000011696889131383332534_)"
    },
    d: "M81.56,29.83 c0.66-0.25,1.35-0.36,2.05-0.34c0.7,0.02,1.39,0.19,2.02,0.48c0.64,0.29,1.21,0.71,1.68,1.22c0.47,0.51,0.84,1.12,1.08,1.78 c0.5,1.33,0.45,2.8-0.13,4.1c-0.58,1.3-1.65,2.31-2.97,2.82c-0.66,0.25-1.35,0.36-2.05,0.34c-0.7-0.02-1.39-0.19-2.02-0.48 c-0.64-0.29-1.21-0.71-1.68-1.22c-0.47-0.51-0.84-1.12-1.08-1.78c-0.5-1.33-0.45-2.8,0.13-4.1 C79.17,31.36,80.24,30.35,81.56,29.83z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000088832327728651933320000004082869669262615484_",
    cx: -397.3709,
    cy: 473.928,
    r: 1,
    gradientTransform: "matrix(-1.5034 -4.0239 -3.9739 1.4847 1322.3271 -2290.0149)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4991C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#D7830D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#9E6115"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#6E4410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#452D13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#251B10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#110D08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#040405"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020203"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088832327728651933320000004082869669262615484_)"
    },
    d: "M34.95,8.62 c0.52-0.2,1.08-0.29,1.64-0.27c0.56,0.02,1.11,0.15,1.61,0.38c0.51,0.23,0.96,0.56,1.34,0.98c0.38,0.41,0.67,0.89,0.86,1.42 c0.4,1.06,0.36,2.24-0.11,3.27c-0.46,1.03-1.32,1.84-2.37,2.25c-0.52,0.2-1.08,0.29-1.64,0.27c-0.56-0.02-1.11-0.15-1.62-0.38 c-0.51-0.23-0.96-0.57-1.34-0.98c-0.38-0.41-0.67-0.89-0.86-1.42c-0.39-1.06-0.36-2.24,0.11-3.27C33.04,9.84,33.9,9.03,34.95,8.62 z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000124152431895082472360000013689388636878117257_",
    cx: -397.3709,
    cy: 473.928,
    r: 1,
    gradientTransform: "matrix(-1.5034 -4.0239 -3.9739 1.4847 1293.3873 -2267.4333)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4991C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#D7830D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#9E6115"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#6E4410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#452D13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#251B10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#110D08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#040405"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020203"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124152431895082472360000013689388636878117257_)"
    },
    d: "M5.96,31.21 c0.52-0.2,1.08-0.29,1.64-0.27c0.56,0.02,1.11,0.15,1.61,0.38c0.51,0.23,0.96,0.56,1.34,0.98c0.38,0.41,0.67,0.89,0.86,1.42 c0.4,1.06,0.36,2.24-0.1,3.27c-0.46,1.03-1.32,1.84-2.38,2.25c-0.52,0.2-1.08,0.29-1.64,0.27c-0.56-0.02-1.11-0.15-1.61-0.38 c-0.51-0.23-0.96-0.56-1.34-0.98c-0.38-0.41-0.67-0.89-0.86-1.42c-0.4-1.06-0.36-2.24,0.11-3.27C4.05,32.43,4.9,31.62,5.96,31.21z "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000042014330385476766050000016221335940943272891_",
    cx: -470.3455,
    cy: 509.3881,
    r: 1,
    gradientTransform: "matrix(-0.777 -2.0796 -2.0538 0.7673 716.4662 -1311.2365)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4991C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#D7830D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#9E6115"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#6E4410"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#452D13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#251B10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#110D08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#040405"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020203"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042014330385476766050000016221335940943272891_)"
    },
    d: "M34.89,55.65 c0.27-0.1,0.56-0.15,0.85-0.14c0.29,0.01,0.57,0.08,0.83,0.2c0.26,0.12,0.5,0.29,0.69,0.5c0.2,0.21,0.35,0.46,0.45,0.73 c0.2,0.55,0.18,1.16-0.06,1.69c-0.24,0.53-0.68,0.95-1.23,1.16c-0.27,0.1-0.56,0.15-0.85,0.14c-0.29-0.01-0.57-0.08-0.83-0.2 c-0.26-0.12-0.5-0.29-0.69-0.5c-0.2-0.21-0.35-0.46-0.45-0.73c-0.2-0.55-0.18-1.16,0.06-1.69C33.9,56.28,34.34,55.86,34.89,55.65z "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000008870049408787422190000009163446994674387342_",
    cx: -480.8578,
    cy: 514.4961,
    r: 1,
    gradientTransform: "matrix(-0.7264 -1.9443 -1.9201 0.7174 722.3092 -1281.0227)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2F519F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#2C4C9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#233A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#242F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#1B2140"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#101325"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#06080F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#020304"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020203"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008870049408787422190000009163446994674387342_)"
    },
    d: "M82.98,20.99 c0.25-0.1,0.52-0.14,0.79-0.13c0.27,0.01,0.54,0.07,0.78,0.18c0.25,0.11,0.47,0.27,0.65,0.47c0.18,0.2,0.33,0.43,0.42,0.69 c0.19,0.51,0.17,1.08-0.05,1.58c-0.23,0.5-0.64,0.89-1.15,1.09c-0.25,0.1-0.52,0.14-0.79,0.13c-0.27-0.01-0.53-0.07-0.78-0.18 c-0.25-0.11-0.47-0.27-0.65-0.47c-0.18-0.2-0.32-0.43-0.42-0.68c-0.19-0.51-0.18-1.08,0.05-1.58 C82.06,21.58,82.47,21.19,82.98,20.99z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000025404094921002107470000009487046501588587176_",
    cx: -480.8578,
    cy: 514.4965,
    r: 1,
    gradientTransform: "matrix(-0.7264 -1.9443 -1.9201 0.7174 724.0143 -1254.3527)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2F519F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#2C4C9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#233A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#242F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#1B2140"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#101325"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#06080F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#020304"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020203"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025404094921002107470000009487046501588587176_)"
    },
    d: "M84.6,47.62 c0.25-0.1,0.52-0.14,0.79-0.13c0.27,0.01,0.54,0.07,0.78,0.19c0.25,0.11,0.47,0.27,0.65,0.47c0.18,0.2,0.32,0.43,0.42,0.69 c0.19,0.51,0.17,1.08-0.05,1.58c-0.22,0.5-0.64,0.89-1.15,1.09c-0.25,0.1-0.52,0.14-0.79,0.13c-0.27-0.01-0.54-0.07-0.78-0.19 c-0.25-0.11-0.47-0.27-0.65-0.47c-0.18-0.2-0.32-0.43-0.42-0.69c-0.19-0.51-0.17-1.08,0.05-1.58 C83.68,48.21,84.09,47.82,84.6,47.62z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.0f7d3015ce6a473328932abc9859417e.svg";
export { ForwardRef as ReactComponent };